<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftReasonDetail from '../../../../shift_reasons/components/ShiftReasonDetail.vue'
import { ShiftReasonID } from '../../../../shift_reasons/models/shiftReason'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Business',
                route: '/(app)/settings/business/',
            },
            {
                label: 'Buildings',
                route: '/(app)/settings/buildings/',
            },
            {
                label: 'Skills',
                route: '/(app)/settings/skills/',
            },
            {
                label: 'Groups',
                route: '/(app)/settings/groups/',
            },
            {
                label: 'Shift Reasons',
                route: '/(app)/settings/shift-reasons/',
            },
        ],
    }
})

const {
  id,
} = defineProps<{
    id: ShiftReasonID
}>()
</script>

<template>
  <ShiftReasonDetail
    :id="id"
  />
</template>